export default __webpack_public_path__ + "static/media/comfort_plus.950bffd9.svg";